// ****** Libraries ******
import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import './App.scss'
import WebFont from 'webfontloader'

// ****** Pages ******
import Layout from './Components/Layout'
import Dashboard from './Pages/Dashboard'
import Login from './Pages/Login'
import Logout from './Pages/Logout'
import Courses from './Pages/Courses'
import Branches from './Pages/Branches'
import Requests from './Pages/Requests'
import Candidates from './Pages/Candidates'
import Groups from './Pages/Groups'
import Students from './Pages/Students'
import Classes from './Pages/Classes'
import Exams from './Pages/Exams'
import ExamTypes from './Pages/ExamTypes'
import Teachers from './Pages/Teachers'
import Payments from './Pages/Payments'
import Expenses from './Pages/Expenses'
import Reports from './Pages/Reports'
import Settings from './Pages/Settings'
import NotFound from './Pages/NotFound'


function App () {
  useEffect(() => {
    WebFont.load({
      google: {
        families: ['Google Sans:100,200,300,400,500,600,700,800', 'sans-serif']
      }
    })
  }, [])

  return (
    <>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route path='/' element={<Dashboard />} />
          <Route path='/courses' element={<Courses />} />
          <Route path='/courses/:id/:formName?' element={<Courses />} />
          <Route path='/branches' element={<Branches />} />
          <Route path='/branches/:id/:formName?' element={<Branches />} />
          <Route path='/groups' element={<Groups />} />
          <Route path='/groups/:id/:formName?' element={<Groups />} />
          <Route path='/requests' element={<Requests />} />        
          <Route path='/requests/:id/:formName?' element={<Requests />} />
          <Route path='/candidates' element={<Candidates />} />        
          <Route path='/candidates/:id/:formName?' element={<Candidates />} />
          <Route path='/classes' element={<Classes />} />
          <Route path='/classes/:id/:formName?' element={<Classes />} />
          <Route path='/exams' element={<Exams />} />
          <Route path='/exams/:id/:formName?' element={<Exams />} />
          <Route path='/examTypes' element={<ExamTypes />} />
          <Route path='/examTypes/:id/:formName?' element={<ExamTypes />} />
          <Route path='/students' element={<Students />} />
          <Route path='/students/:id/:formName?' element={<Students />} />
          <Route path='/teachers' element={<Teachers />} />
          <Route path='/teachers/:id/:formName?' element={<Teachers />} />
          <Route path='/payments' element={<Payments />} />
          <Route path='/payments/:id/:formName?' element={<Payments />} />
          <Route path='/expenses' element={<Expenses />} />
          <Route path='/expenses/:id/:formName?' element={<Expenses />} />
          <Route path='/reports' element={<Reports />} />
          <Route path='/reports/:report' element={<Reports />} />
          <Route path='/settings' element={<Settings />} />
          <Route path='/settings/:id' element={<Settings />} />
        </Route>

        <Route path='/login' element={<Login />} />
        <Route path='/logout' element={<Logout />} />
        <Route path='/*' element={<NotFound />} />
      </Routes>
    </>
  )
}

export default App
